import(/* webpackMode: "eager" */ "/Users/timantos/Projects/SagenceWebsite/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/Users/timantos/Projects/SagenceWebsite/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/Users/timantos/Projects/SagenceWebsite/src/components/sections/WhitepaperForm.tsx");
